/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspaidneedspayouts3Inputs */

const en_ticketspaidneedspayouts3 = /** @type {(inputs: Ticketspaidneedspayouts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For paid tickets you set up payouts with Stripe once, right after this. Until then they cannot be bought.`)
};

const de_ticketspaidneedspayouts3 = /** @type {(inputs: Ticketspaidneedspayouts3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für bezahlte Tickets richtest du danach einmal Auszahlungen mit Stripe ein. Bis dahin sind sie nicht buchbar.`)
};

/**
* | output |
* | --- |
* | "For paid tickets you set up payouts with Stripe once, right after this. Until then they cannot be bought." |
*
* @param {Ticketspaidneedspayouts3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspaidneedspayouts3 = /** @type {((inputs?: Ticketspaidneedspayouts3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspaidneedspayouts3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspaidneedspayouts3(inputs)
	return de_ticketspaidneedspayouts3(inputs)
});
export { ticketspaidneedspayouts3 as "ticketsPaidNeedsPayouts" }